module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("WYATT CORTLAND")]), _vm._v(" was sweating in the stifling heat, swinging the sledgehammer into the wall, working out his anger with every impact. His shirt was soaked, and he could hear the other two guys on the crew upstairs taking out the bathroom and the bedroom walls. They put him down in the living room because he was the new guy and there was only one window, meaning by the time they ended the workday, he’d be covered in sweat, dust, and grime. He didn’t care, and he wiped his sweaty forehead with a sweaty forearm. Wyatt dropped the hammer on the floor and grabbed a piece of the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Something square and dusty caught his eye. Leaning against a beam, it was covered in dirt and grime, and he stared at it for a moment. Wyatt bent down and pulled it out of the wall. It was a metal box, not too heavy, still locked and covered in dust. The hinges weren’t rusted, just dirty. Wyatt could hear something moving around inside the box when he carefully shook it. More than one something. He’d heard stories about people finding hidden fortunes in walls. Money. Jewelry. He listened to the guys banging away upstairs and quietly left the house. He slipped the box underneath the passenger seat of his pickup truck. Wyatt took a minute to light up a quick cigarette and take a few drags before he went back in, picked up the hammer, and swung again.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-987ea62a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0005.vue
// module id = 69
// module chunks = 0